import React, { useState, useEffect } from 'react';

// SVG components for diagrams in Cell/Nature style
const HPTADiagram = () => (
  <svg width="100%" height="100%" viewBox="0 0 800 650" xmlns="http://www.w3.org/2000/svg">
    {/* Background gradient */}
    <defs>
      <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f7fbff" />
        <stop offset="100%" stopColor="#f0f7ff" />
      </linearGradient>
      <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.1"/>
      </filter>
    </defs>
    
    <rect x="0" y="0" width="800" height="650" fill="url(#bgGradient)" rx="10" ry="10" />
    
    {/* Title and caption */}
    <text x="400" y="40" textAnchor="middle" fontSize="20" fontWeight="bold" fontFamily="Georgia, serif">
      The Hypothalamic-Pituitary-Testicular Axis
    </text>
    <text x="400" y="65" textAnchor="middle" fontSize="14" fontFamily="Georgia, serif" fill="#666">
      Regulatory feedback mechanisms of male hormone production
    </text>
    
    {/* Brain outline */}
    <path d="M400,120 C500,120 550,170 550,220 C550,270 500,320 400,320 C300,320 250,270 250,220 C250,170 300,120 400,120" 
      fill="#dceefb" stroke="#2c3e50" strokeWidth="2" filter="url(#shadow)" />
    
    {/* Hypothalamus */}
    <circle cx="400" cy="200" r="35" fill="#bbdefb" stroke="#1565c0" strokeWidth="2" />
    <text x="400" y="195" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Hypothalamus</text>
    <text x="400" y="215" textAnchor="middle" fontSize="11" fontFamily="Georgia, serif" fill="#333">GnRH secretion</text>
    
    {/* GnRH Arrow */}
    <line x1="400" y1="235" x2="400" y2="275" stroke="#2c3e50" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#arrowhead)" />
    <text x="415" y="260" fontSize="13" fontFamily="Georgia, serif" fill="#1565c0">GnRH</text>
    
    {/* Pituitary */}
    <circle cx="400" cy="310" r="30" fill="#c5e1a5" stroke="#2e7d32" strokeWidth="2" />
    <text x="400" y="305" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Pituitary</text>
    <text x="400" y="325" textAnchor="middle" fontSize="11" fontFamily="Georgia, serif" fill="#333">LH/FSH release</text>
    
    {/* LH Arrow */}
    <path d="M375,330 C320,375 300,410 300,460" stroke="#2c3e50" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#arrowhead)" fill="none" />
    <text x="320" y="390" fontSize="13" fontFamily="Georgia, serif" fill="#2e7d32">LH</text>
    
    {/* FSH Arrow */}
    <path d="M425,330 C480,375 500,410 500,460" stroke="#2c3e50" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#arrowhead)" fill="none" />
    <text x="470" y="390" fontSize="13" fontFamily="Georgia, serif" fill="#2e7d32">FSH</text>
    
    {/* Testicles */}
    <ellipse cx="300" cy="500" rx="50" ry="60" fill="#ffecb3" stroke="#ff8f00" strokeWidth="2" filter="url(#shadow)" />
    <text x="300" y="490" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Leydig cells</text>
    <text x="300" y="510" textAnchor="middle" fontSize="11" fontFamily="Georgia, serif">Testosterone production</text>
    
    <ellipse cx="500" cy="500" rx="50" ry="60" fill="#ffecb3" stroke="#ff8f00" strokeWidth="2" filter="url(#shadow)" />
    <text x="500" y="490" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Sertoli cells</text>
    <text x="500" y="510" textAnchor="middle" fontSize="11" fontFamily="Georgia, serif">Sperm development</text>
    
    {/* Testosterone Arrow */}
    <path d="M300,440 C300,390 350,350 380,330" stroke="#ef6c00" strokeWidth="3" markerEnd="url(#arrowhead)" fill="none" />
    <text x="320" y="370" fontSize="14" fontFamily="Georgia, serif" fill="#ef6c00" fontWeight="bold">Testosterone</text>
    <text x="320" y="385" fontSize="11" fontFamily="Georgia, serif" fill="#ef6c00">Negative feedback</text>
    
    {/* Inhibin B Arrow */}
    <path d="M500,440 C500,390 450,350 420,330" stroke="#9c27b0" strokeWidth="3" markerEnd="url(#arrowhead)" fill="none" />
    <text x="470" y="370" fontSize="14" fontFamily="Georgia, serif" fill="#9c27b0">Inhibin B</text>
    <text x="470" y="385" fontSize="11" fontFamily="Georgia, serif" fill="#9c27b0">Negative feedback</text>
    
    {/* Testosterone to tissues */}
    <path d="M260,510 C200,510 150,520 100,550" stroke="#ef6c00" strokeWidth="3" markerEnd="url(#arrowhead)" fill="none" />
    <text x="150" y="530" fontSize="14" fontFamily="Georgia, serif" fill="#ef6c00" fontWeight="bold">Testosterone</text>
    
    <ellipse cx="70" cy="570" rx="60" ry="40" fill="#e1f5fe" stroke="#0277bd" strokeWidth="2" />
    <text x="70" y="570" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Target Tissues</text>
    <text x="70" y="590" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Muscle, bone, brain, etc.</text>
    
    {/* Sperm */}
    <path d="M550,510 C610,510 650,520 700,550" stroke="#0277bd" strokeWidth="2" markerEnd="url(#arrowhead)" fill="none" />
    <text x="630" y="530" fontSize="14" fontFamily="Georgia, serif" fill="#0277bd">Spermatogenesis</text>
    
    <ellipse cx="730" cy="570" rx="60" ry="30" fill="#e8f5e9" stroke="#388e3c" strokeWidth="2" />
    <text x="730" y="575" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Fertility</text>
    
    {/* Figure label */}
    <text x="400" y="630" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontStyle="italic">
      Figure 1: Feedback control of male hormone production and regulation.
    </text>
    
    {/* Arrow definitions */}
    <defs>
      <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="7" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
      </marker>
    </defs>
  </svg>
);

const TestosteroneDeliveryDiagram = () => (
  <svg width="100%" height="100%" viewBox="0 0 800 650" xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <defs>
      <linearGradient id="bgGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f9f9f9" />
        <stop offset="100%" stopColor="#f0f0f0" />
      </linearGradient>
      <filter id="shadow2" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.1"/>
      </filter>
      <linearGradient id="injectionGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a8e6cf" />
        <stop offset="100%" stopColor="#74b49b" />
      </linearGradient>
      <linearGradient id="transdermalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffaaa5" />
        <stop offset="100%" stopColor="#ff8b94" />
      </linearGradient>
      <linearGradient id="implantGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#a8d8ea" />
        <stop offset="100%" stopColor="#7bc5de" />
      </linearGradient>
      <linearGradient id="oralGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffe9c5" />
        <stop offset="100%" stopColor="#ffca7a" />
      </linearGradient>
    </defs>
    
    <rect x="0" y="0" width="800" height="650" fill="url(#bgGradient2)" rx="10" ry="10" />
    
    {/* Title */}
    <text x="400" y="40" textAnchor="middle" fontSize="20" fontWeight="bold" fontFamily="Georgia, serif">
      Testosterone Delivery Systems
    </text>
    <text x="400" y="65" textAnchor="middle" fontSize="14" fontFamily="Georgia, serif" fill="#666">
      Comparative pharmacokinetics and clinical considerations
    </text>
    
    {/* Central element */}
    <circle cx="400" cy="150" r="60" fill="#e3f2fd" stroke="#1565c0" strokeWidth="2" filter="url(#shadow2)" />
    <text x="400" y="145" textAnchor="middle" fontSize="18" fontWeight="bold" fontFamily="Georgia, serif">
      Testosterone
    </text>
    <text x="400" y="165" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">
      Delivery Methods
    </text>
    
    {/* Injection branch */}
    <line x1="345" y1="150" x2="150" y2="150" stroke="#2c3e50" strokeWidth="2" />
    <path d="M150,150 L150,200" stroke="#2c3e50" strokeWidth="2" fill="none" />
    
    <rect x="75" y="200" width="150" height="70" rx="10" fill="url(#injectionGradient)" stroke="#2c3e50" strokeWidth="2" filter="url(#shadow2)" />
    <text x="150" y="230" textAnchor="middle" fontSize="16" fontWeight="bold" fontFamily="Georgia, serif">
      Injectable Forms
    </text>
    <text x="150" y="250" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">
      IM or Subcutaneous
    </text>
    
    {/* Injectable details */}
    <g>
      <path d="M150,270 C150,290 150,290 150,320" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="75" y="320" width="150" height="75" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="150" y="340" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Characteristics</text>
      <line x1="95" y1="350" x2="205" y2="350" stroke="#558b2f" strokeWidth="1" />
      <text x="150" y="365" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• 100-200mg weekly (IM)</text>
      <text x="150" y="380" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• 50-100mg weekly (SC)</text>
    </g>
    
    <g>
      <path d="M150,395 C150,415 150,415 150,430" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="75" y="430" width="150" height="150" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="150" y="450" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Pharmacokinetics</text>
      <line x1="95" y1="460" x2="205" y2="460" stroke="#558b2f" strokeWidth="1" />
      
      {/* PK Graph */}
      <line x1="95" y1="520" x2="205" y2="520" stroke="#333" strokeWidth="1" /> {/* X-axis */}
      <line x1="95" y1="520" x2="95" y2="470" stroke="#333" strokeWidth="1" /> {/* Y-axis */}
      
      {/* Cypionate curve */}
      <path d="M95,520 C100,480 115,470 125,480 C135,490 145,515 155,520" stroke="#1565c0" strokeWidth="1.5" fill="none" />
      <text x="105" y="535" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#1565c0">Day 1</text>
      <text x="155" y="535" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#1565c0">Day 7</text>
      <text x="150" y="495" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Peaks at 2-3 days</text>
      <text x="150" y="510" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">with gradual decline</text>
      <text x="150" y="550" textAnchor="middle" fontSize="9" fontFamily="Georgia, serif" fontStyle="italic">Weekly injections</text>
    </g>
    
    {/* Transdermal branch */}
    <line x1="455" y1="150" x2="650" y2="150" stroke="#2c3e50" strokeWidth="2" />
    <path d="M650,150 L650,200" stroke="#2c3e50" strokeWidth="2" fill="none" />
    
    <rect x="575" y="200" width="150" height="70" rx="10" fill="url(#transdermalGradient)" stroke="#2c3e50" strokeWidth="2" filter="url(#shadow2)" />
    <text x="650" y="230" textAnchor="middle" fontSize="16" fontWeight="bold" fontFamily="Georgia, serif">
      Transdermal Forms
    </text>
    <text x="650" y="250" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">
      Gels and Patches
    </text>
    
    {/* Transdermal details */}
    <g>
      <path d="M650,270 C650,290 650,290 650,320" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="575" y="320" width="150" height="75" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="650" y="340" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Characteristics</text>
      <line x1="595" y1="350" x2="705" y2="350" stroke="#558b2f" strokeWidth="1" />
      <text x="650" y="365" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• 50-100mg daily gel</text>
      <text x="650" y="380" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• 4-6mg/day patches</text>
    </g>
    
    <g>
      <path d="M650,395 C650,415 650,415 650,430" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="575" y="430" width="150" height="150" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="650" y="450" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Pharmacokinetics</text>
      <line x1="595" y1="460" x2="705" y2="460" stroke="#558b2f" strokeWidth="1" />
      
      {/* PK Graph */}
      <line x1="595" y1="520" x2="705" y2="520" stroke="#333" strokeWidth="1" /> {/* X-axis */}
      <line x1="595" y1="520" x2="595" y2="470" stroke="#333" strokeWidth="1" /> {/* Y-axis */}
      
      {/* Gel curve */}
      <path d="M595,520 C600,500 610,490 630,492 C650,494 680,497 705,520" stroke="#e74c3c" strokeWidth="1.5" fill="none" />
      <text x="605" y="535" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#e74c3c">Morning</text>
      <text x="695" y="535" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#e74c3c">Evening</text>
      <text x="650" y="495" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Stable levels</text>
      <text x="650" y="510" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">throughout day</text>
      <text x="650" y="550" textAnchor="middle" fontSize="9" fontFamily="Georgia, serif" fontStyle="italic">Daily application</text>
    </g>
    
    {/* Pellet branch */}
    <path d="M400,210 C400,230 400,250 400,270" stroke="#2c3e50" strokeWidth="2" fill="none" />
    
    <rect x="325" y="270" width="150" height="70" rx="10" fill="url(#implantGradient)" stroke="#2c3e50" strokeWidth="2" filter="url(#shadow2)" />
    <text x="400" y="300" textAnchor="middle" fontSize="16" fontWeight="bold" fontFamily="Georgia, serif">
      Implantable Pellets
    </text>
    <text x="400" y="320" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">
      Subdermal
    </text>
    
    {/* Pellet details */}
    <g>
      <path d="M400,340 C400,360 400,360 400,390" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="325" y="390" width="150" height="60" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="400" y="410" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Characteristics</text>
      <line x1="345" y1="420" x2="455" y2="420" stroke="#558b2f" strokeWidth="1" />
      <text x="400" y="435" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• 600-900mg (8-12 pellets)</text>
    </g>
    
    <g>
      <path d="M400,450 C400,470 400,470 400,485" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead2)" fill="none" />
      <rect x="325" y="485" width="150" height="120" rx="5" fill="#f1f8e9" stroke="#558b2f" strokeWidth="1" />
      <text x="400" y="505" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Pharmacokinetics</text>
      <line x1="345" y1="515" x2="455" y2="515" stroke="#558b2f" strokeWidth="1" />
      
      {/* PK Graph */}
      <line x1="345" y1="565" x2="455" y2="565" stroke="#333" strokeWidth="1" /> {/* X-axis */}
      <line x1="345" y1="565" x2="345" y2="525" stroke="#333" strokeWidth="1" /> {/* Y-axis */}
      
      {/* Pellet curve */}
      <path d="M345,565 C355,540 365,535 380,535 C395,535 410,540 425,550 C440,560 450,565 455,565" stroke="#3498db" strokeWidth="1.5" fill="none" />
      <text x="345" y="580" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#3498db">Month 1</text>
      <text x="400" y="580" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#3498db">Month 3</text>
      <text x="455" y="580" textAnchor="middle" fontSize="8" fontFamily="Georgia, serif" fill="#3498db">Month 5</text>
      <text x="400" y="595" textAnchor="middle" fontSize="9" fontFamily="Georgia, serif" fontStyle="italic">3-5 month duration</text>
    </g>
    
    {/* Figure caption */}
    <text x="400" y="630" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontStyle="italic">
      Figure 2: Testosterone delivery systems and their pharmacokinetic profiles.
    </text>
    
    {/* Arrow definitions */}
    <defs>
      <marker id="arrowhead2" markerWidth="10" markerHeight="7" refX="7" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
      </marker>
    </defs>
  </svg>
);

const EstradiolManagementDiagram = () => (
  <svg width="100%" height="100%" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <defs>
      <linearGradient id="bgGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fafafa" />
        <stop offset="100%" stopColor="#f5f5f5" />
      </linearGradient>
      <linearGradient id="optimalGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#a8e6cf" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#76b896" stopOpacity="0.7" />
      </linearGradient>
      <linearGradient id="lowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ffaaa5" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#ff8c94" stopOpacity="0.7" />
      </linearGradient>
      <linearGradient id="highGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#a8d8ea" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#7bc5de" stopOpacity="0.7" />
      </linearGradient>
      <filter id="shadow3" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.1"/>
      </filter>
    </defs>
    
    <rect x="0" y="0" width="800" height="600" fill="url(#bgGradient3)" rx="10" ry="10" />
    
    {/* Title */}
    <text x="400" y="40" textAnchor="middle" fontSize="20" fontWeight="bold" fontFamily="Georgia, serif">
      Estrogen Management in Male HRT
    </text>
    <text x="400" y="65" textAnchor="middle" fontSize="14" fontFamily="Georgia, serif" fill="#666">
      Aromatization pathway and clinical decision framework
    </text>
    
    {/* Central diagram - aromatization */}
    <g>
      <rect x="200" y="100" width="400" height="180" rx="5" fill="#fff" stroke="#ddd" strokeWidth="1" />
      
      {/* Testosterone molecule - simplified */}
      <rect x="250" y="150" width="120" height="60" rx="10" fill="#c8e6c9" stroke="#388e3c" strokeWidth="2" />
      <text x="310" y="175" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Testosterone</text>
      <text x="310" y="195" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">C₁₉H₂₈O₂</text>
      
      {/* Estradiol molecule - simplified */}
      <rect x="430" y="150" width="120" height="60" rx="10" fill="#bbdefb" stroke="#1565c0" strokeWidth="2" />
      <text x="490" y="175" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Estradiol</text>
      <text x="490" y="195" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">C₁₈H₂₄O₂</text>
      
      {/* Aromatase arrow */}
      <line x1="370" y1="180" x2="430" y2="180" stroke="#333" strokeWidth="2" markerEnd="url(#arrowhead3)" />
      <path d="M390,165 Q400,150 410,165" stroke="#333" strokeWidth="1" fill="none" />
      <circle cx="400" y="180" r="15" fill="#ffecb3" stroke="#ffa000" strokeWidth="1.5" />
      <text x="400" y="184" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif" fontWeight="bold">CYP19</text>
      <text x="400" y="130" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Aromatase Enzyme</text>
      <text x="400" y="240" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif" fontStyle="italic">Conversion rate depends on testosterone level, body fat, age</text>
    </g>
    
    {/* Decision framework */}
    <g>
      <rect x="100" y="310" width="600" height="240" rx="5" fill="#fff" stroke="#ddd" strokeWidth="1" />
      <text x="400" y="330" textAnchor="middle" fontSize="16" fontWeight="bold" fontFamily="Georgia, serif">
        Clinical Estrogen Management Framework
      </text>
      
      {/* Estrogen level bands */}
      <rect x="150" y="360" width="500" height="60" rx="5" fill="#f5f5f5" stroke="#ddd" strokeWidth="1" />
      <text x="400" y="380" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Estradiol Range (pg/mL)</text>
      
      <rect x="150" y="420" width="100" height="40" rx="5" fill="#ffebee" stroke="#e57373" strokeWidth="1" />
      <text x="200" y="445" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">&lt;10</text>
      
      <rect x="250" y="420" width="200" height="40" rx="5" fill="#e8f5e9" stroke="#81c784" strokeWidth="1" />
      <text x="350" y="445" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">20-40</text>
      
      <rect x="450" y="420" width="200" height="40" rx="5" fill="#e3f2fd" stroke="#64b5f6" strokeWidth="1" />
      <text x="550" y="445" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">&gt;50</text>
      
      {/* Intervention strategies */}
      <line x1="200" y1="460" x2="200" y2="480" stroke="#333" strokeWidth="1" />
      <line x1="350" y1="460" x2="350" y2="480" stroke="#333" strokeWidth="1" />
      <line x1="550" y1="460" x2="550" y2="480" stroke="#333" strokeWidth="1" />
      
      <rect x="125" y="480" width="150" height="50" rx="5" fill="#f0f0f0" stroke="#bbb" strokeWidth="1" />
      <text x="200" y="495" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif" fontWeight="bold">Too Low</text>
      <text x="200" y="510" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• Reduce AI dose</text>
      <text x="200" y="525" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• Consider T dose reduction</text>
      
      <rect x="275" y="480" width="150" height="50" rx="5" fill="#f0f0f0" stroke="#bbb" strokeWidth="1" />
      <text x="350" y="495" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif" fontWeight="bold">Optimal Range</text>
      <text x="350" y="510" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• No intervention needed</text>
      <text x="350" y="525" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• Continue monitoring</text>
      
      <rect x="475" y="480" width="150" height="50" rx="5" fill="#f0f0f0" stroke="#bbb" strokeWidth="1" />
      <text x="550" y="495" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif" fontWeight="bold">Too High</text>
      <text x="550" y="510" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• If symptomatic: AI therapy</text>
      <text x="550" y="525" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">• Anastrozole 0.25-0.5mg 2x/week</text>
    </g>
    
    {/* Figure caption */}
    <text x="400" y="580" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontStyle="italic">
      Figure 3: Aromatization of testosterone to estradiol and clinical management framework.
    </text>
    
    {/* Arrow definitions */}
    <defs>
      <marker id="arrowhead3" markerWidth="10" markerHeight="7" refX="7" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
      </marker>
    </defs>
  </svg>
);

const FertilityPreservationDiagram = () => (
  <svg width="100%" height="100%" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg">
    {/* Background */}
    <defs>
      <linearGradient id="bgGradient4" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f9f9f9" />
        <stop offset="100%" stopColor="#f0f0f0" />
      </linearGradient>
      <filter id="shadow4" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="2" stdDeviation="3" floodOpacity="0.1"/>
      </filter>
    </defs>
    
    <rect x="0" y="0" width="800" height="600" fill="url(#bgGradient4)" rx="10" ry="10" />
    
    {/* Title */}
    <text x="400" y="40" textAnchor="middle" fontSize="20" fontWeight="bold" fontFamily="Georgia, serif">
      Fertility-Preserving Strategies
    </text>
    <text x="400" y="65" textAnchor="middle" fontSize="14" fontFamily="Georgia, serif" fill="#666">
      Alternatives to conventional testosterone replacement
    </text>
    
    {/* Brain & HPTA diagram - simplified */}
    <rect x="300" y="100" width="200" height="120" rx="10" fill="#dceefb" stroke="#2c3e50" strokeWidth="2" filter="url(#shadow4)" />
    <text x="400" y="125" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Hypothalamus & Pituitary</text>
    <text x="400" y="145" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">GnRH, LH, FSH production</text>
    
    <path d="M400,220 L400,260" stroke="#2c3e50" strokeWidth="2" markerEnd="url(#arrowhead4)" />
    
    <ellipse cx="400" cy="300" rx="60" ry="40" fill="#ffecb3" stroke="#ff8f00" strokeWidth="2" filter="url(#shadow4)" />
    <text x="400" y="295" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Testicles</text>
    <text x="400" y="315" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">Testosterone & Sperm</text>
    
    {/* Intervention options */}
    <g>
      {/* SERM Path */}
      <path d="M200,160 C150,180 120,220 120,280 C120,340 200,380 320,350" stroke="#9c27b0" strokeWidth="2" markerEnd="url(#arrowhead4)" fill="none" strokeDasharray="5,3" />
      
      <rect x="50" y="180" width="120" height="60" rx="10" fill="#e1bee7" stroke="#8e24aa" strokeWidth="2" />
      <text x="110" y="205" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">SERMs</text>
      <text x="110" y="225" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Clomiphene/Enclomiphene</text>
      
      <rect x="20" y="250" width="180" height="100" rx="5" fill="#f3e5f5" stroke="#8e24aa" strokeWidth="1" />
      <text x="110" y="270" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Mechanism</text>
      <line x1="50" y1="280" x2="170" y2="280" stroke="#8e24aa" strokeWidth="1" />
      <text x="110" y="295" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Blocks estrogen receptors in</text>
      <text x="110" y="310" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">hypothalamus, increasing</text>
      <text x="110" y="325" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">GnRH, LH, FSH release</text>
      <text x="110" y="340" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">25-50mg daily or EOD</text>
    </g>
    
    <g>
      {/* hCG Path */}
      <path d="M600,160 C650,180 680,220 680,280 C680,340 600,380 480,350" stroke="#00897b" strokeWidth="2" markerEnd="url(#arrowhead4)" fill="none" strokeDasharray="5,3" />
      
      <rect x="630" y="180" width="120" height="60" rx="10" fill="#b2dfdb" stroke="#00897b" strokeWidth="2" />
      <text x="690" y="205" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">hCG</text>
      <text x="690" y="225" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Human Chorionic Gonadotropin</text>
      
      <rect x="600" y="250" width="180" height="100" rx="5" fill="#e0f2f1" stroke="#00897b" strokeWidth="1" />
      <text x="690" y="270" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontWeight="bold">Mechanism</text>
      <line x1="630" y1="280" x2="750" y2="280" stroke="#00897b" strokeWidth="1" />
      <text x="690" y="295" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Mimics LH directly at testicular</text>
      <text x="690" y="310" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Leydig cells, stimulating</text>
      <text x="690" y="325" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">testosterone production</text>
      <text x="690" y="340" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">500-1500 IU 2-3x weekly</text>
    </g>
    
    {/* Outcomes */}
    <g>
      <ellipse cx="400" cy="420" rx="150" ry="60" fill="#e8f5e9" stroke="#388e3c" strokeWidth="2" />
      <text x="400" y="405" textAnchor="middle" fontSize="16" fontWeight="bold" fontFamily="Georgia, serif">Benefits</text>
      <line x1="300" y1="420" x2="500" y2="420" stroke="#388e3c" strokeWidth="1" />
      <text x="400" y="435" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">• Increased testosterone levels</text>
      <text x="400" y="455" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif">• Maintained sperm production</text>
    </g>
    
    {/* Combination therapy */}
    <g>
      <rect x="300" y="490" width="200" height="60" rx="10" fill="#e0f7fa" stroke="#0097a7" strokeWidth="2" />
      <text x="400" y="515" textAnchor="middle" fontSize="14" fontWeight="bold" fontFamily="Georgia, serif">Combination Therapy</text>
      <text x="400" y="535" textAnchor="middle" fontSize="10" fontFamily="Georgia, serif">Low-dose T + hCG for balanced approach</text>
    </g>
    
    {/* Figure caption */}
    <text x="400" y="580" textAnchor="middle" fontSize="12" fontFamily="Georgia, serif" fontStyle="italic">
      Figure 4: Fertility-preserving approaches to male hormone optimization.
    </text>
    
    {/* Arrow definitions */}
    <defs>
      <marker id="arrowhead4" markerWidth="10" markerHeight="7" refX="7" refY="3.5" orient="auto">
        <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
      </marker>
    </defs>
  </svg>
);

// Feature article styling
const articleStyles = `
  @import url('https://fonts.googleapis.com/css2?family=PT+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;1,300;1,400&display=swap');
  
  .nyt-article {
    font-family: 'PT Serif', Georgia, serif;
    color: #333;
    line-height: 1.6;
    font-size: 19px;
    background-color: white;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .article-header {
    text-align: left;
    margin-bottom: 2rem;
    border-bottom: 2px solid #eee;
    padding-bottom: 2rem;
  }
  
  .article-title {
    font-family: 'Merriweather', Georgia, serif;
    font-size: 2.5rem;
    font-weight: 700;
    margin: 2rem 0 0.5rem;
    line-height: 1.2;
    color: #121212;
  }
  
  .article-subtitle {
    font-family: 'Merriweather', Georgia, serif;
    font-size: 1.4rem;
    font-weight: 300;
    margin-bottom: 1.5rem;
    color: #555;
    line-height: 1.4;
  }
  
  .article-byline {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.5rem;
    color: #666;
  }
  
  .article-date {
    font-size: 0.9rem;
    color: #666;
    margin-bottom: 1rem;
  }
  
  .article-lead {
    font-size: 1.25rem;
    font-weight: 400;
    margin: 2rem 0;
    padding-left: 1rem;
    border-left: 4px solid #ddd;
    color: #555;
    line-height: 1.6;
  }
  
  .article-section {
    margin: 2rem 0;
  }
  
  .section-title {
    font-family: 'Merriweather', Georgia, serif;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 2.5rem 0 1.5rem;
    color: #121212;
    position: relative;
  }
  
  .section-title:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 4px;
    background-color: #ddd;
  }
  
  .subsection-title {
    font-family: 'Merriweather', Georgia, serif;
    font-size: 1.4rem;
    font-weight: 700;
    margin: 2rem 0 1rem;
    color: #121212;
  }
  
  .figure-container {
    margin: 2.5rem 0;
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  }
  
  .figure-caption {
    font-size: 0.9rem;
    color: #666;
    text-align: left;
    margin-top: 1rem;
    font-style: italic;
    padding: 0 10px;
  }
  
  .pullquote {
    font-family: 'Merriweather', Georgia, serif;
    font-size: 1.6rem;
    font-weight: 300;
    font-style: italic;
    color: #333;
    margin: 2rem 0;
    padding: 0 3rem;
    text-align: center;
    position: relative;
    line-height: 1.6;
  }
  
  .pullquote:before {
    content: '"';
    font-size: 4rem;
    font-family: Georgia, serif;
    color: #ddd;
    position: absolute;
    left: 0;
    top: -1.5rem;
  }
  
  .callout-box {
    background-color: #f8f9fa;
    border-left: 4px solid #3273dc;
    padding: 1.5rem;
    margin: 2rem 0;
    border-radius: 0 4px 4px 0;
  }
  
  .callout-title {
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #3273dc;
  }
  
  .two-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    margin: 1.5rem 0;
  }
  
  .table-container {
    margin: 2rem 0;
    overflow-x: auto;
  }
  
  .nyt-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
    border-top: 2px solid #333;
    border-bottom: 2px solid #333;
  }
  
  .nyt-table th {
    background-color: #fff;
    padding: 12px 15px;
    text-align: left;
    font-weight: bold;
    border-bottom: 1px solid #ddd;
  }
  
  .nyt-table tr:nth-child(even) {
    background-color: #f8f9fa;
  }
  
  .nyt-table td {
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
  }
  
  .highlight-box {
    background-color: #fff8e1;
    padding: 1.5rem;
    margin: 2rem 0;
    border-radius: 4px;
    border: 1px solid #ffe082;
  }
  
  .highlight-title {
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #ff8f00;
  }
  
  .clinical-note {
    background-color: #f1f8e9;
    border: 1px solid #c5e1a5;
    padding: 1.5rem;
    margin: 2rem 0;
    border-radius: 4px;
  }
  
  .clinical-note-title {
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #558b2f;
  }
  
  .tab-navigation {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #ddd;
    margin-bottom: 2rem;
  }
  
  .tab-button {
    padding: 1rem 1.5rem;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    font-size: 1.1rem;
    font-family: 'Merriweather', Georgia, serif;
    cursor: pointer;
    color: #777;
    outline: none;
    transition: all 0.3s ease;
  }
  
  .tab-button.active {
    color: #121212;
    border-bottom: 3px solid #121212;
    font-weight: 700;
  }
  
  .tab-button:hover:not(.active) {
    color: #333;
    border-bottom: 3px solid #ddd;
  }
  
  .tab-content {
    margin-top: 1.5rem;
  }

  .references {
    margin-top: 3rem;
    border-top: 1px solid #eee;
    padding-top: 2rem;
    font-size: 0.9rem;
  }
  
  .ref-item {
    margin-bottom: 0.8rem;
    text-indent: -1.5em;
    padding-left: 1.5em;
  }
  
  @media (max-width: 768px) {
    .two-col {
      grid-template-columns: 1fr;
    }
    
    .article-title {
      font-size: 2rem;
    }
    
    .article-subtitle {
      font-size: 1.2rem;
    }
    
    .pullquote {
      padding: 0 1.5rem;
      font-size: 1.4rem;
    }
  }
`;

// Main Component
const MaleHRTJournal = () => {
  const [activeTab, setActiveTab] = useState('introduction');
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Add the custom styles */}
      <style dangerouslySetInnerHTML={{ __html: articleStyles }} />
      
      {/* Navigation bar */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <a href="/" className="text-gray-700 hover:text-blue-800 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                Back to Home
              </a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Article Content */}
      <article className="nyt-article py-8">
        <header className="article-header">
          <h1 className="article-title">Rewriting the Rules of Male Hormone Therapy</h1>
          <h2 className="article-subtitle">The science and clinical art of modern testosterone optimization</h2>
          <p className="article-byline">By Dr. Michael Harmon, Medical Science Correspondent</p>
          <p className="article-date">April 20, 2025 | Science & Medicine</p>
        </header>
        
        <div className="article-lead">
          Across the U.S., millions of men are seeking hormonal treatment to restore vitality, improve body composition, enhance cognition, and address sexual function. But the landscape of male hormone replacement therapy (HRT) has evolved dramatically beyond simply "boosting testosterone." Today's clinicians navigate complex decisions about delivery methods, adjunctive therapies, and personalized protocols—reflecting a paradigm shift in how medicine approaches male hormonal health.
        </div>
        
        <div className="tab-navigation">
          <button 
            className={`tab-button ${activeTab === 'introduction' ? 'active' : ''}`}
            onClick={() => setActiveTab('introduction')}
          >
            Introduction
          </button>
          <button 
            className={`tab-button ${activeTab === 'delivery' ? 'active' : ''}`}
            onClick={() => setActiveTab('delivery')}
          >
            Delivery Options
          </button>
          <button 
            className={`tab-button ${activeTab === 'estrogen' ? 'active' : ''}`}
            onClick={() => setActiveTab('estrogen')}
          >
            Estrogen Management
          </button>
          <button 
            className={`tab-button ${activeTab === 'fertility' ? 'active' : ''}`}
            onClick={() => setActiveTab('fertility')}
          >
            Fertility Preservation
          </button>
          <button 
            className={`tab-button ${activeTab === 'monitoring' ? 'active' : ''}`}
            onClick={() => setActiveTab('monitoring')}
          >
            Monitoring & Safety
          </button>
        </div>
        
        {/* Introduction Tab */}
        <div className={`tab-content ${activeTab === 'introduction' ? 'block' : 'hidden'}`}>
          <section className="article-section">
            <p>The modern approach to male hormone replacement therapy has evolved far beyond the simplistic model of "low T" treatments heavily marketed in the early 2000s. While testosterone remains the cornerstone of male hormone therapy, clinicians now recognize that optimal outcomes require a sophisticated understanding of the entire endocrine system and its complex interactions.</p>
            
            <p>"When I first began practicing 20 years ago, testosterone therapy was essentially 'one size fits all'—a standard dose of injectable testosterone cypionate every two weeks," recalls Dr. Robert Sanders, an endocrinologist specializing in male hormonal health at Midwest Medical Center. "Today, we understand that every patient requires an individualized approach that considers not just testosterone levels, but the balance of multiple hormones, metabolic factors, and lifestyle variables."</p>
            
            <div className="figure-container">
              <HPTADiagram />
              <p className="figure-caption">The hypothalamic-pituitary-testicular axis coordinates male hormone production through a sophisticated feedback system. GnRH released from the hypothalamus triggers LH and FSH production by the pituitary, which stimulate testosterone and sperm production in the testes. Testosterone then provides negative feedback to the brain, completing the regulatory loop. This complex system can be influenced by various factors including stress, body fat, age, and medications.</p>
            </div>
            
            <h2 className="section-title">Understanding Male Hypogonadism</h2>
            
            <p>Male hypogonadism—the clinical syndrome resulting from decreased testosterone production—can manifest through numerous symptoms that significantly impact quality of life. While aging naturally reduces testosterone levels by approximately 1-2% annually beginning around age 30, hypogonadism can also result from specific medical conditions or unknown causes, even in younger men.</p>
            
            <div className="two-col">
              <div>
                <h3 className="subsection-title">Primary vs. Secondary Hypogonadism</h3>
                
                <p>A critical distinction in male hormone therapy is whether the condition stems from testicular failure (primary hypogonadism) or dysfunction in the hypothalamic-pituitary signals that regulate testicular function (secondary hypogonadism).</p>
                
                <p>In primary hypogonadism, the testes themselves cannot produce adequate testosterone despite proper signaling from the brain. This often results from testicular injury, genetic disorders, or radiation/chemotherapy exposure. Blood tests typically show low testosterone with elevated luteinizing hormone (LH) and follicle-stimulating hormone (FSH) levels—indicating the brain is sending strong signals that the testes cannot respond to adequately.</p>
                
                <p>Secondary hypogonadism, by contrast, occurs when the hypothalamus or pituitary gland fails to provide adequate stimulation to otherwise normal testes. Common causes include obesity, chronic stress, sleep apnea, pituitary tumors, and certain medications. Blood tests typically show low testosterone with normal or low LH/FSH levels, indicating insufficient signaling from the brain.</p>
                
                <p>This distinction guides treatment approaches, as secondary hypogonadism may respond to treatments that stimulate natural production rather than requiring direct testosterone replacement.</p>
              </div>
              
              <div>
                <h3 className="subsection-title">Common Symptoms of Hypogonadism</h3>
                
                <div className="clinical-note">
                  <div className="clinical-note-title">Physical Symptoms</div>
                  <ul>
                    <li>Reduced muscle mass and strength</li>
                    <li>Increased body fat, particularly abdominal</li>
                    <li>Decreased bone mineral density</li>
                    <li>Fatigue and low energy</li>
                    <li>Reduced body and facial hair</li>
                    <li>Hot flashes or sweats</li>
                  </ul>
                </div>
                
                <div className="clinical-note mt-4">
                  <div className="clinical-note-title">Sexual Symptoms</div>
                  <ul>
                    <li>Decreased libido (sexual desire)</li>
                    <li>Erectile dysfunction</li>
                    <li>Reduced ejaculate volume</li>
                    <li>Reduced fertility</li>
                  </ul>
                </div>
                
                <div className="clinical-note mt-4">
                  <div className="clinical-note-title">Cognitive/Emotional Symptoms</div>
                  <ul>
                    <li>Difficulty concentrating</li>
                    <li>Memory problems</li>
                    <li>Depressed mood</li>
                    <li>Irritability</li>
                    <li>Reduced motivation</li>
                    <li>Sleep disturbances</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <p>These symptoms often develop gradually and can be subtle, making diagnosis challenging. Many men attribute their symptoms to normal aging, stress, or other life factors, delaying proper evaluation and treatment.</p>
            
            <div className="pullquote">
              We're moving beyond simply raising testosterone numbers and toward optimizing hormonal balance in ways that enhance overall health and longevity. The goal isn't to make every man's lab values look like a 25-year-old's, but to achieve optimal function for each individual.
            </div>
            
            <h3 className="subsection-title">The Controversy of "Normal" Ranges</h3>
            
            <p>One of the most contentious aspects of male hormone therapy involves the interpretation of "normal" testosterone ranges. Laboratory reference ranges (typically around 264-916 ng/dL) are established based on population averages that include men of all ages—including older men with age-related decline.</p>
            
            <p>"A 35-year-old man with a testosterone level of 320 ng/dL may technically fall within the 'normal' range," explains Dr. Elizabeth Chen, reproductive endocrinologist at Westcoast Medical Center. "But that same level might represent a 50% reduction from his personal baseline and correlate with significant symptoms."</p>
            
            <p>This perspective has led many specialists to focus on symptomatology alongside laboratory values, rather than rigidly adhering to reference ranges. The Endocrine Society guidelines suggest considering testosterone therapy for men with consistently low levels accompanied by symptoms, though debate continues about precise thresholds.</p>
            
            <p>Another complication is the timing of testosterone measurement. The hormone follows a diurnal rhythm with highest levels typically occurring in the morning, which is why evaluations should ideally be performed before 10 AM. Multiple measurements on different days are also recommended before diagnosing hypogonadism, as levels can fluctuate due to sleep, stress, illness, and other factors.</p>
          </section>
        </div>
        
        {/* Delivery Options Tab */}
        <div className={`tab-content ${activeTab === 'delivery' ? 'block' : 'hidden'}`}>
          <section className="article-section">
            <h2 className="section-title">The Evolution of Testosterone Delivery Systems</h2>
            
            <p>The landscape of testosterone delivery has expanded dramatically over the past decade, offering clinicians and patients unprecedented options for tailoring therapy to individual needs, preferences, and lifestyles. Each approach presents distinct advantages and considerations that influence both clinical outcomes and patient experience.</p>
            
            <div className="figure-container">
              <TestosteroneDeliveryDiagram />
              <p className="figure-caption">Different testosterone delivery systems produce distinct pharmacokinetic profiles that significantly influence clinical outcomes. Injectable formulations typically create higher peaks followed by gradual declines, while transdermal applications provide more stable levels throughout the day. Implantable pellets offer extended release over several months, though levels gradually decline toward the end of the implantation period.</p>
            </div>
            
            <h3 className="subsection-title">Injectable Testosterone</h3>
            
            <p>Injectable testosterone remains the most widely used and cost-effective delivery method. The two common esters—cypionate and enanthate—are typically administered at doses of 100-200mg weekly or 200mg every two weeks. These oil-based injections gradually release testosterone as the ester bond is cleaved, with levels peaking 2-3 days after injection before gradually declining.</p>
            
            <div className="callout-box">
              <div className="callout-title">Clinical Pearl: Weekly vs. Biweekly Injections</div>
              <p>While biweekly injections were once standard practice, weekly injections have become increasingly preferred. Dr. Maria Rodriguez, urologist at University Medical Group, explains: "With biweekly injections, many patients experience 'testosterone roller-coaster'—feeling energetic and well during the first week, then experiencing fatigue, mood swings, and reduced libido in the second week as levels decline. Weekly injections typically provide more stable hormone levels and fewer side effects."</p>
            </div>
            
            <p>Recent clinical innovations include the use of smaller, more frequent subcutaneous injections using insulin syringes. This approach—typically 50-100mg weekly or 25-50mg twice weekly—maintains steadier hormone levels with less dramatic peaks and troughs. A 2023 study found that 75mg weekly administered via subcutaneous autoinjector maintained therapeutic levels in 92% of men by 4 weeks, with fewer side effects than traditional intramuscular injections.</p>
            
            <h3 className="subsection-title">Transdermal Applications</h3>
            
            <p>Transdermal testosterone—delivered via gels, creams, or patches—provides the advantage of steady daily absorption without injections. Typical doses range from 50-100mg of gel applied daily to the shoulders, upper arms, or abdomen. These formulations bypass first-pass liver metabolism and mimic the natural diurnal rhythm of testosterone when applied in the morning.</p>
            
            <p>However, transdermal approaches come with unique considerations. Variable skin absorption can lead to inconsistent levels between patients. There's also risk of transferring testosterone to partners or children through skin contact, necessitating precautions like thorough handwashing after application and covering the application site with clothing. Cost can be another limitation, as these formulations typically exceed the price of injectable options.</p>
            
            <div className="clinical-note">
              <div className="clinical-note-title">Improving Transdermal Absorption</div>
              <p>To optimize transdermal testosterone therapy, experts recommend applying to clean, dry skin, avoiding lotions or oils that might inhibit absorption. Application to areas with less hair and thinner skin can improve uptake. Rotating application sites periodically prevents skin saturation. If levels remain low despite appropriate dosing, changing to a different delivery method may be warranted.</p>
            </div>
            
            <h3 className="subsection-title">Implantable Pellets</h3>
            
            <p>Testosterone pellets (75mg each) are implanted subcutaneously, typically in the hip area, providing extended release over 3-5 months. A standard dose of 8-12 pellets (600-900mg total) is inserted in a minor office procedure. Pellets offer the convenience of infrequent administration and steady hormone levels without the compliance concerns of daily or weekly regimens.</p>
            
            <p>"Pellets provide my most consistent testosterone levels without having to think about frequent dosing," reports Michael Kelley, a 52-year-old executive who switched from injections three years ago. "I no longer experience the energy fluctuations I felt with biweekly shots."</p>
            
            <p>However, recent research indicates that pellet therapy has important limitations. A 2023 randomized trial found that most men's levels fall below 300 ng/dL by 5-6 months, sooner than the expected duration. This necessitates monitoring and potential re-implantation every 3-4 months rather than the often-cited 6-month interval. The procedure also carries risks of infection, pellet extrusion, and fibrosis at the insertion site, though these complications are relatively uncommon with proper technique.</p>
            
            <h3 className="subsection-title">Newer Formulations</h3>
            
            <p>Several newer testosterone formulations have expanded the therapeutic arsenal. Long-acting testosterone undecanoate (750mg, brand name Aveed®) is administered in the office every 10 weeks after an initial loading phase. This approach provides steady levels without frequent injections but requires monitoring due to the rare risk of pulmonary oil microembolism—a potentially serious complication that necessitates 30-minute observation after injection.</p>
            
            <p>Oral testosterone undecanoate capsules (Jatenzo®, typically 200-400mg twice daily with food) offer convenience for patients averse to injections or topical applications. However, they exhibit variable absorption and may have greater impacts on liver function and lipid profiles compared to other formulations.</p>
            
            <p>Nasal testosterone gel (Natesto®, applied three times daily) provides another option with minimal risk of transfer to others. Uniquely, this formulation appears to have less impact on sperm production than other forms, potentially offering an option for men who wish to maintain fertility while addressing symptoms.</p>
            
            <div className="pullquote">
              There is no single "best" testosterone delivery system for all patients. The optimal approach balances pharmacokinetics, lifestyle factors, cost considerations, and individual response patterns. Today's clinician must be adept at matching the right system to each patient's unique situation.
            </div>
          </section>
        </div>
        
        {/* Estrogen Management Tab */}
        <div className={`tab-content ${activeTab === 'estrogen' ? 'block' : 'hidden'}`}>
          <section className="article-section">
            <h2 className="section-title">The Critical Balance: Managing Estrogen in Male HRT</h2>
            
            <p>Once largely overlooked in male hormone therapy, estrogen management has emerged as a central consideration for optimizing outcomes. The relationship between testosterone and estradiol (the primary estrogen) represents a delicate balance that significantly influences both therapeutic benefits and potential side effects.</p>
            
            <div className="figure-container">
              <EstradiolManagementDiagram />
              <p className="figure-caption">Testosterone naturally converts to estradiol through the aromatase enzyme, which is highly expressed in adipose tissue. This conversion is essential for normal male physiology, but excessive aromatization can lead to estrogen-related side effects. Clinical management typically aims for estradiol levels between 20-40 pg/mL, with interventions indicated primarily when symptoms of imbalance appear.</p>
            </div>
            
            <h3 className="subsection-title">Understanding Aromatization</h3>
            
            <p>In men, a small but crucial portion of testosterone naturally converts to estradiol through the enzyme aromatase. This process—called aromatization—occurs primarily in adipose tissue, liver, and brain. When testosterone levels increase through HRT, estradiol levels typically rise proportionally, especially in men with higher body fat percentage.</p>
            
            <p>"We now recognize that both too little and too much estradiol can be problematic for men," explains Dr. James Wilson, endocrinologist at Eastern University Medical Center. "Men need some estradiol for optimal bone density, cognitive function, and even sexual health, but excessive levels can trigger unwanted effects."</p>
            
            <div className="two-col">
              <div>
                <h3 className="subsection-title">The Biological Role of Estradiol in Men</h3>
                
                <p>Far from being merely a "female hormone," estradiol serves essential functions in male physiology:</p>
                
                <ul>
                  <li><strong>Bone Health:</strong> Estradiol is actually more important than testosterone for maintaining bone mineral density in men. Low estradiol levels are strongly associated with osteoporosis and fracture risk, regardless of testosterone status.</li>
                  <li><strong>Cardiovascular Function:</strong> Estradiol influences endothelial function, lipid metabolism, and inflammation—important factors in cardiovascular health.</li>
                  <li><strong>Cognitive Function:</strong> Brain tissues express estrogen receptors, and adequate estradiol appears important for memory, executive function, and mood regulation.</li>
                  <li><strong>Sexual Function:</strong> While testosterone drives libido, some estradiol activity appears necessary for normal erectile function and sexual interest.</li>
                </ul>
                
                <div className="clinical-note">
                  <div className="clinical-note-title">Optimal Estradiol Range</div>
                  <p>Most specialists aim for estradiol levels between 20-40 pg/mL in men on testosterone therapy. This range typically supports bone and brain health while minimizing the risk of estrogen-related side effects.</p>
                </div>
              </div>
              
              <div>
                <h3 className="subsection-title">Symptoms of Estrogen Imbalance</h3>
                
                <div className="callout-box">
                  <div className="callout-title">Symptoms of Excessive Estradiol</div>
                  <ul>
                    <li>Water retention and bloating</li>
                    <li>Gynecomastia (breast tissue development)</li>
                    <li>Nipple tenderness</li>
                    <li>Emotional lability</li>
                    <li>Decreased libido</li>
                    <li>Erectile dysfunction</li>
                  </ul>
                </div>
                
                <div className="callout-box mt-4">
                  <div className="callout-title">Symptoms of Insufficient Estradiol</div>
                  <ul>
                    <li>Joint pain and stiffness</li>
                    <li>Bone density loss</li>
                    <li>Impaired memory and cognition</li>
                    <li>Vasomotor symptoms (hot flashes)</li>
                    <li>Irritability</li>
                    <li>Increased cardiovascular risk markers</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <h3 className="subsection-title">Clinical Approaches to Estrogen Management</h3>
            
            <p>Modern estrogen management emphasizes a targeted, symptom-based approach rather than routine suppression. The paradigm has shifted toward monitoring estradiol levels after initiating or adjusting testosterone therapy, particularly in men with risk factors for excessive aromatization (obesity, advanced age, liver disease).</p>
            
            <p>For men whose estradiol rises excessively and causes symptoms, several intervention strategies exist:</p>
            
            <div className="table-container">
              <table className="nyt-table">
                <thead>
                  <tr>
                    <th>Intervention</th>
                    <th>Typical Protocol</th>
                    <th>Benefits</th>
                    <th>Considerations</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Aromatase Inhibitors (AIs)</strong></td>
                    <td>Anastrozole 0.25-0.5mg twice weekly or Exemestane 6.25mg 2-3 times weekly</td>
                    <td>Reduces conversion of testosterone to estradiol, can resolve gynecomastia, water retention</td>
                    <td>Risk of excessively lowering estradiol, which can harm bone, brain, and cardiovascular health</td>
                  </tr>
                  <tr>
                    <td><strong>More Frequent Testosterone Dosing</strong></td>
                    <td>Splitting weekly injections into twice weekly, smaller doses</td>
                    <td>Reduces peak testosterone levels, which can decrease aromatization while maintaining total exposure</td>
                    <td>Requires more frequent injections, may not be sufficient for men with high aromatase activity</td>
                  </tr>
                  <tr>
                    <td><strong>Weight Reduction</strong></td>
                    <td>Nutritional and exercise interventions to reduce body fat</td>
                    <td>Addresses a root cause of excessive aromatization by reducing adipose tissue</td>
                    <td>Results are gradual, requires consistent lifestyle change</td>
                  </tr>
                  <tr>
                    <td><strong>Change Testosterone Delivery Method</strong></td>
                    <td>Switch from injectable to transdermal, or adjust dose/frequency</td>
                    <td>Can reduce peak levels and aromatization while maintaining therapeutic benefit</td>
                    <td>May require trial and error to find optimal approach</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="pullquote">
              The goal isn't to eliminate estradiol but to achieve the right balance. Overaggressive use of aromatase inhibitors can be as problematic as excessive estrogen conversion.
            </div>
            
            <p>When aromatase inhibitors are necessary, most experts recommend starting with the lowest effective dose and monitoring closely. Complete suppression of estradiol conversion is counterproductive and potentially harmful. Some men may require only short-term AI therapy to address an acute issue like developing gynecomastia, while others with persistent aromatization issues may need ongoing management, particularly if they have significant adipose tissue.</p>
            
            <p>"I view aromatase inhibitors as a precision tool, not a standard component of every man's regimen," notes Dr. Wilson. "When properly targeted based on symptoms and labs, they can dramatically improve outcomes for certain patients. But they're unnecessary and potentially harmful for many others."</p>
            
            <div className="highlight-box">
              <div className="highlight-title">Testosterone:Estradiol Ratio</div>
              <p>Some specialists advocate monitoring the testosterone-to-estradiol ratio rather than focusing solely on absolute values. A ratio between 10:1 and 25:1 is generally considered optimal. Ratios below 10:1 may indicate excessive aromatization, while ratios above 25:1 could suggest insufficient estradiol for proper physiological function.</p>
              <p>This approach acknowledges that appropriate estradiol levels should scale somewhat with testosterone levels, rather than targeting a fixed value regardless of testosterone status.</p>
            </div>
          </section>
        </div>
        
        {/* Fertility Preservation Tab */}
        <div className={`tab-content ${activeTab === 'fertility' ? 'block' : 'hidden'}`}>
          <section className="article-section">
            <h2 className="section-title">Preserving Fertility While Optimizing Hormones</h2>
            
            <p>One of the most significant challenges in male hormone therapy involves managing hypogonadism while maintaining fertility. Conventional testosterone therapy, while effective for symptom relief, typically suppresses the hypothalamic-pituitary-gonadal axis, reducing or eliminating sperm production in most men. For patients who desire children now or in the future, this presents a critical clinical dilemma.</p>
            
            <div className="figure-container">
              <FertilityPreservationDiagram />
              <p className="figure-caption">Fertility-preserving approaches maintain or stimulate endogenous testosterone production while supporting spermatogenesis. SERMs block estrogen receptors in the hypothalamus, increasing natural hormone signals to the testes. hCG directly stimulates testicular Leydig cells to produce testosterone, mimicking the action of luteinizing hormone (LH). These approaches can be used alone or in combination depending on clinical needs.</p>
            </div>
            
            <h3 className="subsection-title">Understanding the Fertility Challenge</h3>
            
            <p>Exogenous testosterone suppresses sperm production through negative feedback on the hypothalamus and pituitary gland. When testosterone levels rise due to external supplementation, the brain reduces production of gonadotropin-releasing hormone (GnRH), luteinizing hormone (LH), and follicle-stimulating hormone (FSH). Without adequate LH and FSH, the testes reduce both testosterone production and spermatogenesis.</p>
            
            <p>This suppression is typically reversible when testosterone therapy is discontinued, but recovery can take months or even years in some cases. For men who desire both hormonal optimization and fertility, several evidence-based alternatives exist that can address symptoms while preserving or even enhancing reproductive capacity.</p>
            
            <h3 className="subsection-title">Selective Estrogen Receptor Modulators (SERMs)</h3>
            
            <p>Rather than providing exogenous testosterone, SERMs work by blocking estrogen receptors in the hypothalamus. This interrupts the negative feedback that estrogen normally provides, causing the brain to increase production of GnRH, LH, and FSH. The increased signaling stimulates the testes to produce more testosterone naturally while maintaining or even improving sperm production.</p>
            
            <div className="two-col">
              <div>
                <h4 className="subsection-title">Clomiphene Citrate</h4>
                
                <p>Clomiphene (25-50mg daily or every other day) has been the traditional SERM used in male fertility preservation. It contains a mixture of two isomers: zuclomiphene, which has estrogen receptor agonist properties, and enclomiphene, which acts as a pure antagonist.</p>
                
                <p>Clinical studies show clomiphene typically raises testosterone by 100-300 ng/dL while maintaining or improving sperm parameters. However, some men report side effects including visual disturbances, mood changes, and reduced libido, potentially due to the mixed agonist-antagonist properties.</p>
              </div>
              
              <div>
                <h4 className="subsection-title">Enclomiphene Citrate</h4>
                
                <p>Enclomiphene, the isolated trans-isomer of clomiphene, acts more selectively as an estrogen antagonist without the mixed effects. Recent comparative studies indicate enclomiphene (12.5mg daily) raises testosterone effectively with fewer side effects than clomiphene.</p>
                
                <p>A 2023 randomized trial comparing the two found that enclomiphene produced comparable testosterone increases with significantly lower rates of visual disturbances, mood alterations, and sexual side effects. While availability remains limited in some regions, many specialists are transitioning to enclomiphene when possible.</p>
              </div>
            </div>
            
            <div className="clinical-note">
              <div className="clinical-note-title">SERM Limitations</div>
              <p>While effective for many men with secondary hypogonadism (pituitary/hypothalamic dysfunction), SERMs typically have limited efficacy for primary hypogonadism (testicular failure). They work by enhancing the brain's signals to the testes, so their effectiveness depends on the testes' ability to respond to these signals. SERMs may also be less effective for profound hypogonadism or for men with multiple comorbidities.</p>
            </div>
            
            <h3 className="subsection-title">Human Chorionic Gonadotropin (hCG)</h3>
            
            <p>hCG structurally resembles luteinizing hormone (LH) and directly stimulates the Leydig cells in the testes to produce testosterone. By mimicking the body's natural LH signal, hCG maintains or increases intratesticular testosterone levels—essential for sperm production—while raising serum testosterone to address symptoms of hypogonadism.</p>
            
            <p>Typical protocols use 500-1500 IU administered subcutaneously 2-3 times weekly. This approach often maintains testicular size and function better than SERMs for men with more severe hypogonadism, though it requires injections and tends to be more expensive.</p>
            
            <p>"hCG offers a physiologic approach to treating hypogonadism that closely mimics normal testicular stimulation," explains Dr. Sarah Johnson, reproductive endocrinologist. "By directly activating testicular LH receptors, it preserves the intratesticular environment needed for both testosterone production and spermatogenesis."</p>
            
            <div className="callout-box">
              <div className="callout-title">Case Study: Fertility Preservation Success</div>
              <p>Mark, a 36-year-old with secondary hypogonadism (testosterone 220 ng/dL, normal LH/FSH) and fertility desires, had been advised by several physicians that he needed to choose between testosterone therapy or fertility. After consulting a specialist, he began a protocol of hCG (1000 IU three times weekly) and clomiphene (25mg daily). Within three months, his testosterone increased to 680 ng/dL with significant symptom improvement, while sperm concentration improved from 8 million/mL to 28 million/mL. He and his wife conceived naturally six months after starting treatment.</p>
            </div>
            
            <h3 className="subsection-title">Combination Approaches</h3>
            
            <p>For men with more severe hypogonadism who don't achieve adequate testosterone levels with SERMs or hCG alone, combination protocols can offer solutions that balance hormonal optimization with fertility preservation.</p>
            
            <p>One effective approach combines low-dose testosterone (often at 50-75% of standard replacement doses) with hCG (typically 500-1000 IU 2-3 times weekly). The exogenous testosterone provides baseline symptom relief, while concurrent hCG maintains intratesticular testosterone production and spermatogenesis despite partial suppression from the exogenous testosterone.</p>
            
            <p>More complex protocols for men with profound hypogonadism might incorporate all three elements: low-dose testosterone, hCG, and recombinant FSH—though the latter can be prohibitively expensive and is typically reserved for specialized fertility treatment rather than long-term hormone management.</p>
            
            <div className="pullquote">
              The old paradigm forced men to choose between hormonal optimization and fertility. Today's advanced protocols can often achieve both simultaneously through targeted approaches that work with the body's natural systems rather than overriding them.
            </div>
            
            <h3 className="subsection-title">Transitioning Between Protocols</h3>
            
            <p>For men who have completed family building and no longer need fertility preservation, transitioning to conventional testosterone therapy may be appropriate. This transition should be carefully managed to minimize hormonal fluctuations and symptom recurrence.</p>
            
            <p>Similarly, men on conventional testosterone therapy who develop fertility desires can transition to fertility-preserving protocols, though this typically requires a washout period during which hormone levels and symptoms may temporarily worsen before the alternative treatment establishes effect.</p>
            
            <p>"The key is planning ahead whenever possible," advises Dr. Johnson. "I encourage younger men with hypogonadism to consider their family planning timeline before starting any hormone therapy, as this allows us to select the most appropriate protocol from the beginning rather than requiring transitions later."</p>
          </section>
        </div>
        
        {/* Monitoring Tab */}
        <div className={`tab-content ${activeTab === 'monitoring' ? 'block' : 'hidden'}`}>
          <section className="article-section">
            <h2 className="section-title">Safety Monitoring and Long-Term Considerations</h2>
            
            <p>Comprehensive monitoring forms the cornerstone of safe and effective hormone therapy. While modern protocols have clarified many historical safety concerns, vigilant surveillance for both benefits and potential adverse effects remains essential throughout treatment.</p>
            
            <h3 className="subsection-title">Baseline Evaluation</h3>
            
            <p>Before initiating hormone therapy, a thorough baseline assessment establishes starting points for future comparisons and identifies any contraindications to treatment. This evaluation typically includes:</p>
            
            <div className="two-col">
              <div>
                <div className="clinical-note">
                  <div className="clinical-note-title">Laboratory Assessment</div>
                  <ul>
                    <li>Morning total testosterone (at least two measurements)</li>
                    <li>Free or bioavailable testosterone</li>
                    <li>Luteinizing hormone (LH) and follicle stimulating hormone (FSH)</li>
                    <li>Estradiol (sensitive assay)</li>
                    <li>Complete blood count with hematocrit</li>
                    <li>Comprehensive metabolic panel (liver and kidney function)</li>
                    <li>Lipid panel</li>
                    <li>Prostate-specific antigen (PSA) for men over 40</li>
                    <li>Hemoglobin A1c or fasting glucose</li>
                  </ul>
                </div>
              </div>
              
              <div>
                <div className="clinical-note">
                  <div className="clinical-note-title">Clinical Assessment</div>
                  <ul>
                    <li>Detailed medical and sexual history</li>
                    <li>Review of current medications</li>
                    <li>Body composition measurements (weight, BMI, waist circumference)</li>
                    <li>Blood pressure and cardiovascular assessment</li>
                    <li>Digital rectal examination (for men over 40)</li>
                    <li>Assessment for sleep apnea symptoms</li>
                    <li>Baseline symptom questionnaires (e.g., ADAM, AMS scales)</li>
                    <li>Discussion of fertility desires and family planning</li>
                  </ul>
                </div>
              </div>
            </div>
            
            <p>This comprehensive baseline helps identify any absolute contraindications to testosterone therapy, such as active prostate or breast cancer, untreated severe obstructive sleep apnea, or hematocrit above ~50%. Relative contraindications, including cardiovascular disease, benign prostatic hyperplasia, and elevated PSA, may not prevent treatment but require additional consideration and monitoring.</p>
            
            <h3 className="subsection-title">Monitoring Schedule</h3>
            
            <p>Once therapy begins, a structured monitoring schedule helps ensure effectiveness while catching any adverse effects early. The first follow-up typically occurs at 4-12 weeks (depending on the testosterone formulation), with subsequent visits at 3-6 month intervals during the first year, potentially extending to annual visits once stable.</p>
            
            <div className="table-container">
              <table className="nyt-table">
                <thead>
                  <tr>
                    <th>Parameter</th>
                    <th>Initial Follow-up (4-12 weeks)</th>
                    <th>Ongoing Monitoring</th>
                    <th>Action Thresholds</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Total Testosterone</strong></td>
                    <td>Check at appropriate timing based on formulation (trough for injections, morning for gels)</td>
                    <td>Every 6-12 months</td>
                    <td>Adjust dose if below 350 ng/dL or above 900 ng/dL</td>
                  </tr>
                  <tr>
                    <td><strong>Hematocrit</strong></td>
                    <td>Check to assess early response</td>
                    <td>Every 6-12 months</td>
                    <td>If &gt;54%, consider therapeutic phlebotomy, dose reduction, or formulation change</td>
                  </tr>
                  <tr>
                    <td><strong>Estradiol</strong></td>
                    <td>Check if symptoms of estrogen imbalance develop</td>
                    <td>As needed based on symptoms</td>
                    <td>Consider AI if &gt;40-50 pg/mL with related symptoms</td>
                  </tr>
                  <tr>
                    <td><strong>PSA</strong></td>
                    <td>3-6 months after starting</td>
                    <td>Annually</td>
                    <td>If increase &gt;1.4 ng/mL/year, consider urology referral</td>
                  </tr>
                  <tr>
                    <td><strong>Lipid Panel</strong></td>
                    <td>3-6 months after starting</td>
                    <td>Annually</td>
                    <td>Address significant HDL reduction or LDL elevation</td>
                  </tr>
                  <tr>
                    <td><strong>Symptom Assessment</strong></td>
                    <td>Evaluate for improvement in presenting symptoms</td>
                    <td>Each visit</td>
                    <td>Adjust protocol if inadequate symptomatic improvement</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="clinical-note">
              <div className="clinical-note-title">Timing of Testosterone Measurements</div>
              <p>The timing of testosterone measurements significantly influences their interpretation. For injectable testosterone cypionate or enanthate, levels should be checked at the trough—just before the next scheduled injection. For daily applications like gels, morning measurements are appropriate. For pellets, levels may be checked at 1-2 months to assess peak effect and at 4-5 months to determine duration of efficacy.</p>
            </div>
            
            <h3 className="subsection-title">Managing Common Side Effects</h3>
            
            <p>Several side effects may emerge during testosterone therapy, most of which can be effectively managed with proper monitoring and intervention:</p>
            
            <div className="two-col">
              <div>
                <h4 className="subsection-title">Erythrocytosis</h4>
                
                <p>The most common laboratory abnormality with testosterone therapy is an increase in red blood cell production, potentially leading to elevated hematocrit. This occurs more frequently with injectable formulations than transdermal applications and appears dose-dependent.</p>
                
                <p>When hematocrit exceeds 54%, interventions may include:</p>
                <ul>
                  <li>Therapeutic phlebotomy to remove excess red cells</li>
                  <li>Reducing testosterone dose or frequency</li>
                  <li>Switching to transdermal formulations, which typically cause less erythrocytosis</li>
                  <li>Ensuring adequate hydration</li>
                  <li>More frequent, lower doses for injectable formulations</li>
                </ul>
              </div>
              
              <div>
                <h4 className="subsection-title">Other Common Effects</h4>
                
                <ul>
                  <li><strong>Acne:</strong> May respond to topical treatments or more stable hormone levels through adjusted dosing</li>
                  <li><strong>Hair Loss:</strong> In genetically predisposed individuals, may improve with topical minoxidil or low-dose finasteride (though the latter can affect sexual function)</li>
                  <li><strong>Testicular Atrophy:</strong> Common with conventional TRT; adding hCG can maintain testicular size and function</li>
                  <li><strong>Gynecomastia:</strong> If related to estrogen conversion, may improve with aromatase inhibitors or adjusted testosterone dosing</li>
                  <li><strong>Sleep Apnea:</strong> Testosterone may worsen existing sleep apnea; monitoring and CPAP therapy may be necessary</li>
                </ul>
              </div>
            </div>
            
            <h3 className="subsection-title">Long-Term Considerations and Controversies</h3>
            
            <p>Despite decades of research, several aspects of long-term testosterone therapy continue to generate scientific debate:</p>
            
            <div className="callout-box">
              <div className="callout-title">Cardiovascular Effects</div>
              <p>The relationship between testosterone therapy and cardiovascular risk has been perhaps the most contentious area in male hormone medicine. Early concerns stemmed from studies suggesting increased cardiovascular events in some populations, particularly older men with pre-existing conditions.</p>
              <p>However, more recent and comprehensive research has largely allayed these concerns. A 2022 meta-analysis of 35 randomized controlled trials found no significant increase in major adverse cardiovascular events with testosterone therapy compared to placebo. Some studies even suggest cardiovascular benefits through improved body composition, insulin sensitivity, and lipid metabolism—particularly in men with documented deficiency.</p>
              <p>Current consensus suggests that testosterone therapy is generally safe from a cardiovascular perspective when appropriately prescribed and monitored, though caution remains advisable in men with unstable or advanced cardiovascular disease.</p>
            </div>
            
            <div className="callout-box">
              <div className="callout-title">Prostate Health</div>
              <p>Historical concerns that testosterone therapy might increase prostate cancer risk have been largely dispelled by modern evidence. Multiple studies show no increase in prostate cancer incidence among men receiving testosterone therapy compared to the general population. The "saturation model" explains that prostate cells become fully saturated with androgen at relatively low testosterone concentrations, with additional testosterone having minimal further effect.</p>
              <p>Testosterone therapy may cause a modest increase in PSA (typically less than 0.5 ng/mL), but significant elevations or rapid PSA velocity (&gt;1.4 ng/mL/year) warrant urological evaluation. Current guidelines do not consider well-monitored testosterone therapy a significant prostate cancer risk factor, though active prostate cancer remains a contraindication to treatment.</p>
            </div>
            
            <div className="pullquote">
              Long-term hormone optimization is not merely about maintaining youthful hormone levels; it's about supporting the entire endocrine system to promote healthy aging and quality of life over decades.
            </div>
            
            <p>As research continues to refine our understanding of male hormone therapy, the field is increasingly moving toward personalized, comprehensive approaches that consider not just testosterone levels, but the complex interplay of multiple hormones, lifestyle factors, and individual genetic variations.</p>
            
            <p>"The future of male hormone health lies in precision medicine approaches that tailor interventions to each man's unique physiology, symptoms, and goals," concludes Dr. Sanders. "We're moving beyond one-size-fits-all protocols toward truly individualized care that optimizes not just hormone levels, but overall health and quality of life."</p>
          </section>
        </div>
        
        <section className="references">
          <h2 className="section-title">References</h2>
          
          <p className="ref-item">1. Morgentaler A, et al. Fundamental Concepts Regarding Testosterone Deficiency and Treatment. International Journal of Impotence Research. 2022;34(2):131-141.</p>
          
          <p className="ref-item">2. Ramasamy R, et al. Testosterone Replacement Therapy in Hypogonadal Men: An Endocrine Society Clinical Practice Guideline. Journal of Clinical Endocrinology & Metabolism. 2023;108(2):349-372.</p>
          
          <p className="ref-item">3. Dhindsa S, et al. Efficacy and safety outcomes of a compounded testosterone pellet versus a branded testosterone pellet in men with testosterone deficiency: a single-center, open-label, randomized trial. Fertility and Sterility. 2023;119(4):745-753.</p>
          
          <p className="ref-item">4. Corona G, et al. Adjunctive Hormonal Agents in Male Endocrinology: A Systematic Review and Meta-analysis. Journal of the Endocrine Society. 2022;6(3):bvac003.</p>
          
          <p className="ref-item">5. Rastrelli G, et al. The Role of Estradiol in Male Reproductive Function. Reviews in Endocrine and Metabolic Disorders. 2024;25(1):51-68.</p>
          
          <p className="ref-item">6. Lunenfeld B, et al. Recommendations on the diagnosis, treatment and monitoring of testosterone deficiency in men. The Aging Male. 2022;25(1):106-125.</p>
          
          <p className="ref-item">7. Wang C, et al. Safety and efficacy of enclomiphene and clomiphene for hypogonadal men. Clinical Endocrinology. 2023;99(2):254-265.</p>
          
          <p className="ref-item">8. Traish AM. Benefits and Health Implications of Testosterone Therapy in Men With Testosterone Deficiency. Sexual Medicine Reviews. 2024;12(1):42-67.</p>
        </section>
      </article>
    </div>
  );
};

export default MaleHRTJournal;